import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { IAirportCodeList, IGetLocationViewModel } from 'src/app/service/vehicle.model';
import { IFilteredLocationConfig } from 'src/app/model/service-request-model';
import { LocationService } from 'src/app/service/location.service';
import { Subscription } from 'rxjs';
import { AddressManagementFilterEvent } from '../../shared/interfaces/address-management-filter-event.interface';
import { AddressTypeEnum } from '../../shared/enums/address-type.enum';

@Component({
  selector: 'app-address-management-filter',
  templateUrl: './address-management-filter.component.html',
  styleUrls: ['./address-management-filter.component.css'],
})
export class AddressManagementFilterComponent implements OnInit, OnChanges, OnDestroy {
  @Input() forSRPageOrItinerary: string;
  @Input() forOriginOrDestination: string;
  @Input() dropdownId!: string;
  @Input() locationList: IGetLocationViewModel[];
  @Input() customerSelectedBusinessUnitId: string;
  @Input() dropdownIndex: number | null;
  @Input() selectedAddressType: AddressTypeEnum | null = null;
  @Input() selectedAirportCodes: IAirportCodeList[] = [];
  @Input() selectedAirportCode: string | null = null;
  @Input() isTbdVisible = false;
  @Input() includeTBD = false;
  @Output('filteredLocationList') filteredLocationList = new EventEmitter();
  @Output('clearSelectedAddress') clearAlreadySelectedAddress = new EventEmitter();
  @Output() changeAddressType = new EventEmitter<AddressManagementFilterEvent>();
  @Output() tbdChange = new EventEmitter<boolean>();
  private _subscriptions: Subscription = new Subscription();
  public airportCodeDropdownSettings;
  public airportCodeList: IAirportCodeList[] = [];
  public addressType: string;
  public returnConfig: IFilteredLocationConfig;

  constructor(private _locationService: LocationService) {}

  ngOnInit(): void {
    this.initializeReturnConfig();
    this.initializeAirportCodeDropDown();
    this.getAirports();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.initializeReturnConfig();
    if (changes?.customerSelectedBusinessUnitId?.currentValue) {
      this.updateAddressList();
    }

    if (changes['selectedAirportCode']?.currentValue) {
      this.selectedAirportCodes = this.airportCodeList.filter((airport) => airport.airportCode === this.selectedAirportCode);
    }
  }

  ngOnDestroy(): void {
    this._subscriptions.unsubscribe();
  }

  initializeReturnConfig() {
    this.returnConfig = {
      dropdownId: this.dropdownId,
      dropdownIndex: this.dropdownIndex,
      filteredLocationList: [],
      forOriginOrDestination: this.forOriginOrDestination,
      addressFilterConfig: {
        addressType: this.selectedAddressType,
        airportCode: this.selectedAirportCodes,
      },
    };
  }

  initializeAirportCodeDropDown() {
    this.airportCodeDropdownSettings = {
      singleSelection: true,
      idField: 'addressId',
      textField: 'airportCode',
      itemsShowLimit: 2,
      allowSearchFilter: true,
      placeholder: 'Select Airport Code',
      closeDropDownOnSelection: true,
    };
  }

  updateAddressList() {
    let airportCodeAddressList: IGetLocationViewModel[];
    switch (this.selectedAddressType) {
      case 'public':
        this.returnConfig.filteredLocationList = this.locationList?.filter(
          (location) => location.isGlobal != false && location.airportCode === null,
        );
        break;
      case 'private':
        this.returnConfig.filteredLocationList = this.locationList?.filter(
          (location) =>
            location.isGlobal == false && location.airportCode === null && location.businessUnitId === this.customerSelectedBusinessUnitId,
        );
        break;
      case 'airport':
        airportCodeAddressList = this.locationList?.filter((location) => location.airportCode != null);
        this.returnConfig.filteredLocationList =
          this.selectedAirportCodes?.length > 0
            ? airportCodeAddressList?.filter((location) =>
                this.selectedAirportCodes.some((airport) => location.airportCode.includes(airport.airportCode)),
              )
            : [];
        break;
      default:
        this.returnConfig.filteredLocationList = [];
    }

    this.returnConfig.addressFilterConfig.airportCode = this.selectedAirportCodes;

    this.filteredLocationList.emit(this.returnConfig);

    this.changeAddressType.emit({
      dropdownIndex: this.dropdownIndex ?? null,
      addressType: this.selectedAddressType,
      dropDownType: this.dropdownId,
      airportCode: this.selectedAirportCodes?.[0]?.airportCode ?? null,
    });
  }

  clearSelectedAddress() {
    this.clearAlreadySelectedAddress.emit(this.returnConfig);
  }

  getAirports(): void {
    const airportsSubs = this._locationService.airportCodeList$.subscribe((response): void => {
      this.initializeAirportCodeDropDown();
      this.airportCodeList = response;

      if (this.selectedAirportCode) {
        this.selectedAirportCodes = this.airportCodeList.filter((airport) => airport.airportCode === this.selectedAirportCode);
      }
    });

    this._subscriptions.add(airportsSubs);
  }

  onTbdChange(): void {
    this.tbdChange.emit(this.includeTBD);
  }
}
